import React, { useEffect, useState } from 'react';

/** Non-blocking notice when the browser reports offline. */
export const OfflineBanner: React.FC = () => {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false
  );

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 border-b border-warning-border bg-warning-bg px-3 py-2 text-center text-sm text-warning-fg"
    >
      <span className="font-medium">You’re offline.</span>
      <span className="text-warning-fg/90">CRM data may be unavailable until you reconnect.</span>
    </div>
  );
};
